module.exports = __webpack_public_path__ + "static/media/54.2e6d5b83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/54.svg
// module id = 184
// module chunks = 0